import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import sceneLogic from '~/scenes/search/logic'

export default function Breadcrumbs () {
  const {
    startMessage: { teacherCount },
    results: { breadcrumbs }
  } = useValues(sceneLogic)

  return (
    <div className='col-1-1 search-breadcrumbs-row'>
      <div className='search-breadcrumbs'>
        <div className='breadcrumb'>
          <strong>
            <a href={breadcrumbs.root.url}>
              <em>{breadcrumbs.root.title}</em>
            </a>
          </strong>
          {breadcrumbs.links.map(link => (
            <span key={link.url}>
              <a href={link.url}>
                <em>{link.title}</em>
              </a>
            </span>
          ))}
        </div>
      </div>
      {teacherCount ? <h2 className='teacher-count'>{teacherCount}</h2> : null}
    </div>
  )
}
